import { ITreeNodeModel } from "../../../TreeView/Models/Interfaces/ITreeNodeModel";
import { app } from "../../../../Frame/App";
import { sortContent } from "../../../../Areas/Admin/Measures/TreeViewModelConverter/Sorting/CategoryContentSort";
import { TreeNodeModel } from "../../../TreeView/Models/TreeNodeModel";
import { ITreeViewFilter } from "./ITreeViewFilter";
import { TreeViewFilterBase } from "./Base/TreeViewFilterBase";
import { TreeNodeComponent } from "../../NodeComponents/TreeNodeComponent";

/**
 * Pluggable filter module for the tree view. It works under the assumption that the businessmodel
 * has a LanguageStringProperty called nameAll. It also makes the assumption, that the parentProperty for newly
 * created parents is called ("temp" + parentPropery).
 * */
export class AllLevelFilter extends TreeViewFilterBase implements ITreeViewFilter {

    filterModel(flatModel: ITreeNodeModel[],
        searchTerm: string,
        hasIsDeleted?: boolean,
        useGrouping?: boolean) {

        this.setAllInvisible(flatModel);
        let notDeletedNodes = this.filterDeleted(flatModel, hasIsDeleted);

        searchTerm = searchTerm.toLocaleLowerCase();
        let filteredNodes = notDeletedNodes.filter(n => {
            let nameInLanguage: string;
            if (n.businessModel.nameAll && n.businessModel.nameAll.hasOwnProperty('valueEn')) {
                // nameAll Assumption!
                nameInLanguage = n.businessModel.nameAll["value" + app.languageUpperCase] as string;
            }
            else if (n.businessModel.name){
                // name fallback.
                nameInLanguage = n.businessModel.name as string;
            }
            if (nameInLanguage && nameInLanguage.toLocaleLowerCase().indexOf(searchTerm) > -1) {
                return true;
            }
            return false;
        });

        // Set filteredNodes visible
        filteredNodes.forEach(n => n.visible = true);

        // Set parents of filtered Nodes visible - also this has the advantage that we dont have to checkt
        // if a node is already in the filtered model. Much simpler code.
        for (let node of filteredNodes) {
            node.visible = true;
            this.setParentsVisible(node);
            this.setChildrenVisible(node);
        }
    }
}